var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useMemo, useState } from 'react';
import { Button, Card, Checkbox, Select, Space, Table, Tag, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createAdminNewRankCondition, fetchAdminNewRankConditionEvaluationKeys, fetchAdminNewRankConditions, fetchAdminRankingLevels, updateAdminNewRankCondition, updateAdminNewRankConditionSortOrder } from '../cores/api/api-dashboard';
import { NEW_RANK_CONDITION_QUERY_KEY, RANKING_LEVELS_QUERY_KEY, STATUS_COLOR_MAP } from '../contants/option';
import ConditionFormModal from './condition-form';
const resolveConditionStatus = condition => condition.active ? 'active' : 'inactive';
const resolveConditionTypeLabel = condition => {
    if (condition.staff_only)
        return 'スタッフ確認';
    if (condition.evaluation_key)
        return 'キーあり';
    return '手動';
};
const resolveConditionTypeTagColor = condition => {
    if (condition.staff_only)
        return 'orange';
    if (condition.evaluation_key)
        return 'blue';
    return 'default';
};
export default function NewRankConditionPage({ embedded = false }) {
    var _a, _b, _c;
    const _message$useMessage = message.useMessage(), _message$useMessage2 = _slicedToArray(_message$useMessage, 2), messageApi = _message$useMessage2[0], contextHolder = _message$useMessage2[1];
    const _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), selectedLevelId = _useState2[0], setSelectedLevelId = _useState2[1];
    const _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), includeInactive = _useState4[0], setIncludeInactive = _useState4[1];
    const _useState5 = useState(false), _useState6 = _slicedToArray(_useState5, 2), isModalOpen = _useState6[0], setIsModalOpen = _useState6[1];
    const _useState7 = useState(null), _useState8 = _slicedToArray(_useState7, 2), editingCondition = _useState8[0], setEditingCondition = _useState8[1];
    const _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), draggingConditionId = _useState0[0], setDraggingConditionId = _useState0[1];
    const queryClient = useQueryClient();
    const _useQuery = useQuery({
        queryKey: [...RANKING_LEVELS_QUERY_KEY, 'desc'],
        queryFn: () => fetchAdminRankingLevels({
            order_direction: 'desc'
        })
    }), levelsRes = _useQuery.data, levelsLoading = _useQuery.isLoading;
    const levels = useMemo(() => { var _a; return (_a = levelsRes === null || levelsRes === void 0 ? void 0 : levelsRes.data) !== null && _a !== void 0 ? _a : []; }, [levelsRes === null || levelsRes === void 0 ? void 0 : levelsRes.data]);
    const selectedLevel = useMemo(() => { var _a; return (_a = levels.find(level => level.id === selectedLevelId)) !== null && _a !== void 0 ? _a : null; }, [levels, selectedLevelId]);
    React.useEffect(() => {
        if (selectedLevelId || !levels.length)
            return;
        setSelectedLevelId(levels[0].id);
    }, [levels, selectedLevelId]);
    const listQueryKey = [...NEW_RANK_CONDITION_QUERY_KEY, selectedLevelId, includeInactive];
    const _useQuery2 = useQuery({
        queryKey: listQueryKey,
        queryFn: () => fetchAdminNewRankConditions({
            ranking_level_id: selectedLevelId,
            include_inactive: includeInactive
        }),
        enabled: selectedLevelId != null
    }), conditionsRes = _useQuery2.data, conditionsLoading = _useQuery2.isLoading;
    const evaluationKeysQueryKey = [...NEW_RANK_CONDITION_QUERY_KEY, 'evaluation-keys', selectedLevel === null || selectedLevel === void 0 ? void 0 : selectedLevel.code];
    const _useQuery3 = useQuery({
        queryKey: evaluationKeysQueryKey,
        queryFn: () => fetchAdminNewRankConditionEvaluationKeys(selectedLevel.code),
        enabled: Boolean(selectedLevel === null || selectedLevel === void 0 ? void 0 : selectedLevel.code)
    }), evaluationKeysRes = _useQuery3.data;
    const availableKeys = useMemo(() => {
        var _a, _b, _c;
        if (!(selectedLevel === null || selectedLevel === void 0 ? void 0 : selectedLevel.code))
            return [];
        return (_c = (_b = (_a = evaluationKeysRes === null || evaluationKeysRes === void 0 ? void 0 : evaluationKeysRes.data) === null || _a === void 0 ? void 0 : _a[selectedLevel.code]) === null || _b === void 0 ? void 0 : _b.available_evaluation_keys) !== null && _c !== void 0 ? _c : [];
    }, [evaluationKeysRes, selectedLevel === null || selectedLevel === void 0 ? void 0 : selectedLevel.code]);
    const availableCount = (selectedLevel === null || selectedLevel === void 0 ? void 0 : selectedLevel.code) != null ? (_c = (_b = (_a = evaluationKeysRes === null || evaluationKeysRes === void 0 ? void 0 : evaluationKeysRes.data) === null || _a === void 0 ? void 0 : _a[selectedLevel.code]) === null || _b === void 0 ? void 0 : _b.available_count) !== null && _c !== void 0 ? _c : 0 : 0;
    const conditions = useMemo(() => {
        var _a;
        const rows = (_a = conditionsRes === null || conditionsRes === void 0 ? void 0 : conditionsRes.data) !== null && _a !== void 0 ? _a : [];
        return [...rows].sort((a, b) => a.condition_no - b.condition_no);
    }, [conditionsRes === null || conditionsRes === void 0 ? void 0 : conditionsRes.data]);
    const createMutation = useMutation({
        mutationFn: params => createAdminNewRankCondition(selectedLevelId, params),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || response.error || 'Create failed');
            }
            yield Promise.all([queryClient.invalidateQueries({
                    queryKey: listQueryKey
                }), queryClient.invalidateQueries({
                    queryKey: evaluationKeysQueryKey
                })]);
            messageApi.success('条件を作成しました。');
            closeModal();
        })
    });
    const reorderMutation = useMutation({
        mutationFn: updateAdminNewRankConditionSortOrder,
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || response.error || 'Reorder failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: listQueryKey
            });
            messageApi.success('条件の並び順を更新しました。');
        })
    });
    const updateMutation = useMutation({
        mutationFn: ({ id, params }) => updateAdminNewRankCondition(id, params),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || response.error || 'Update failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: listQueryKey
            });
            messageApi.success('条件を更新しました。');
            closeModal();
        })
    });
    const openCreateModal = () => {
        setEditingCondition(null);
        setIsModalOpen(true);
    };
    const openEditModal = condition => {
        setEditingCondition(condition);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setEditingCondition(null);
    };
    const handleDropCondition = (target) => __awaiter(this, void 0, void 0, function* () {
        if (!selectedLevelId)
            return;
        const dragged = conditions.find(condition => condition.id === draggingConditionId);
        setDraggingConditionId(null);
        if (!dragged || dragged.id === target.id)
            return;
        const fromIndex = conditions.findIndex(condition => condition.id === dragged.id);
        const toIndex = conditions.findIndex(condition => condition.id === target.id);
        if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex)
            return;
        const reordered = [...conditions];
        const _reordered$splice = reordered.splice(fromIndex, 1), _reordered$splice2 = _slicedToArray(_reordered$splice, 1), removed = _reordered$splice2[0];
        reordered.splice(toIndex, 0, removed);
        try {
            yield reorderMutation.mutateAsync({
                ranking_level_id: selectedLevelId,
                ordered_ids: reordered.map(condition => condition.id)
            });
        }
        catch (error) {
            messageApi.error(error.message || '並び替えに失敗しました。');
        }
    });
    const handleSubmit = (payload, options) => __awaiter(this, void 0, void 0, function* () {
        try {
            if (options.isCreate) {
                yield createMutation.mutateAsync(payload);
            }
            else if (editingCondition) {
                yield updateMutation.mutateAsync({
                    id: editingCondition.id,
                    params: payload
                });
            }
        }
        catch (error) {
            messageApi.error(error.message || 'Save failed.');
        }
    });
    const columns = [{
            title: 'No.',
            dataIndex: 'condition_no',
            width: 80
        }, {
            title: '名前',
            dataIndex: 'name',
            width: 220,
            render: value => /*#__PURE__*/ React.createElement("span", {
                className: "text-[12px] font-medium text-[#111827]"
            }, value || '-')
        }, {
            title: '説明',
            dataIndex: 'description',
            render: value => /*#__PURE__*/ React.createElement("div", {
                className: "line-clamp-2 text-[12px] text-[#6b7280]"
            }, value || '—')
        }, {
            title: '種別',
            width: 120,
            render: (_, record) => {
                const label = resolveConditionTypeLabel(record);
                return /*#__PURE__*/ React.createElement(Tag, {
                    color: resolveConditionTypeTagColor(record)
                }, label);
            }
        }, {
            title: 'ステータス',
            width: 100,
            render: (_, record) => {
                const status = resolveConditionStatus(record);
                return /*#__PURE__*/ React.createElement(Tag, {
                    color: STATUS_COLOR_MAP[status]
                }, status === 'active' ? '有効' : '無効');
            }
        }, {
            title: '',
            key: 'action',
            width: 100,
            render: (_, record) => /*#__PURE__*/ React.createElement(Button, {
                onClick: () => openEditModal(record)
            }, "\u7DE8\u96C6")
        }];
    return /*#__PURE__*/ React.createElement("div", {
        className: embedded ? '' : 'min-h-screen bg-[#f5f5f5] px-6 py-6'
    }, contextHolder, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: "mb-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap items-end justify-between gap-4"
    }, /*#__PURE__*/ React.createElement(Space, {
        wrap: true,
        size: "large",
        align: "end"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "mb-1 text-[12px] text-[#6b7280]"
    }, "Rank"), /*#__PURE__*/ React.createElement(Select, {
        style: {
            minWidth: 220
        },
        loading: levelsLoading,
        value: selectedLevelId !== null && selectedLevelId !== void 0 ? selectedLevelId : undefined,
        onChange: value => setSelectedLevelId(value),
        options: levels.map(level => ({
            value: level.id,
            label: `${level.code} — ${level.name}`
        }))
    })), /*#__PURE__*/ React.createElement(Checkbox, {
        checked: includeInactive,
        onChange: event => setIncludeInactive(event.target.checked)
    }, "\u975E\u30A2\u30AF\u30C6\u30A3\u30D6\u3082\u8868\u793A")), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: openCreateModal,
        disabled: !selectedLevelId
    }, "\u6761\u4EF6\u8FFD\u52A0"))), /*#__PURE__*/ React.createElement(Card, {
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-0 text-[13px] text-[#6b7280]"
    }, "\u884C\u3092\u30C9\u30E9\u30C3\u30B0\u3057\u3066\u4E26\u3073\u66FF\u3048\u3067\u304D\u307E\u3059\uFF08No. \u304C\u66F4\u65B0\u3055\u308C\u307E\u3059\uFF09\u3002 \u6761\u4EF6\u306F\u8AAC\u660E\u306E\u307F\u3067\u8FFD\u52A0\u3067\u304D\u307E\u3059\uFF08\u7BA1\u7406\u8005\u304C\u624B\u52D5\u78BA\u8A8D\uFF09\u3002", availableCount === 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, ' ', "\u30DE\u30B9\u30BF\u30FC\u30AD\u30FC\u306F\u5168\u3066\u4F7F\u7528\u4E2D\u3067\u3059\u3002\u81EA\u52D5\u5224\u5B9A\u7528\u30AD\u30FC\u304C\u5FC5\u8981\u306A\u5834\u5408\u306F\u4F5C\u6210\u6642\u306B\u300C\u8A2D\u5B9A\u3059\u308B\u300D\u304B\u3089\u30AB\u30B9\u30BF\u30E0\u5165\u529B\u3067\u304D\u307E\u3059\u3002") : /*#__PURE__*/ React.createElement(React.Fragment, null, ' ', "\u672A\u4F7F\u7528\u306E\u30DE\u30B9\u30BF\u30FC\u30AD\u30FC\u304C ", availableCount, " \u4EF6\u3042\u308A\u307E\u3059\uFF08\u4F5C\u6210\u6642\u306B\u4EFB\u610F\u3067\u8A2D\u5B9A\u53EF\u80FD\uFF09\u3002"))), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        loading: conditionsLoading || levelsLoading || reorderMutation.isPending,
        columns: columns,
        dataSource: conditions,
        pagination: {
            pageSize: 20
        },
        scroll: {
            x: 960
        },
        onRow: record => ({
            draggable: conditions.length > 1,
            onDragStart: () => {
                setDraggingConditionId(record.id);
            },
            onDragOver: event => {
                event.preventDefault();
            },
            onDrop: () => {
                void handleDropCondition(record);
            },
            onDragEnd: () => {
                setDraggingConditionId(null);
            },
            className: draggingConditionId === record.id ? 'cursor-grabbing opacity-60' : conditions.length > 1 ? 'cursor-grab' : undefined
        })
    }))), selectedLevel ? /*#__PURE__*/ React.createElement(ConditionFormModal, {
        open: isModalOpen,
        editingCondition: editingCondition,
        rankingLevelCode: selectedLevel.code,
        availableKeys: availableKeys,
        loading: createMutation.isPending || updateMutation.isPending,
        onCancel: closeModal,
        onSubmit: handleSubmit
    }) : null);
}
